<template>
  <UiModal
    ref="reviewCardModal"
    :title="t('modal.title')"
    :is-shown="modalIsOpen"
    :size="UiModalSize.S"
    is-scrollbar-width-ignored
    is-footer-hidden
    @close="closeModal"
  >
    <template
      v-if="review"
      #content
    >
      <review-card
        :default-sogu-fields="defaultSoguFields"
        :review
        :options="{ maxTitleLines: 10, maxLines: 100 }"
        force-expand
        @gallery-slider-closed="returnFocusToModal"
      />
    </template>
  </UiModal>
</template>

<script setup lang="ts">
  import ReviewCard from './ReviewCard.vue';
  import type { ExperienceReview } from '@/entities/review';
  import { UiModal, UiModalSize } from '@experience/core-modal-ui';
  import { useI18n } from '@experience/i18n';
  import ru from '../i18n/ru.json';
  import type { ContextGeoSubject } from '@/shared/types/geography.ts';
  import { ref } from 'vue';

  const reviewCardModal = ref<null | { setFocusOnModal: () => void }>(null);

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  interface Props {
    defaultSoguFields: ContextGeoSubject;
  }

  defineProps<Props>();

  const review = defineModel<ExperienceReview | null>();
  const modalIsOpen = computed(() => !!review.value);

  const closeModal = () => {
    review.value = null;
  };

  const returnFocusToModal = () => {
    reviewCardModal.value?.setFocusOnModal();
  };
</script>
